import React from "react";
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

import { userDetailsFilters } from "../../@signals";


export default function numColumn(name, label, showDetails=false) {
    return {
        name: name, label: label,
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: (value, row) => <Box>
                {value}
                {!!showDetails && <IconSeeker
                    icon="circle-info"
                    tooltip="View user details"
                    sx={{ ml: 1, fontSize: '1rem', cursor: 'pointer'  }}
                    onClick={() => {
                        userDetailsFilters.value = row
                    }}
                />}
            </Box>
        }
    }
}